.list {
  display: grid;
  gap: var(--space-2);
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.player {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  color: var(--color-text-primary);
  background: var(--color-surface-subtle);
}
.player[data-self] {
  box-shadow: inset 0 0 0 1px var(--color-brand);
}
.avatar {
  display: grid;
  width: var(--space-10);
  height: var(--space-10);
  flex: none;
  place-items: center;
  border-radius: var(--radius-pill);
  background: var(--room-player-background, var(--color-play-party));
  color: var(--color-play-card-text);
  font-weight: 800;
}
.rank {
  display: grid;
  width: var(--space-6);
  flex: none;
  place-items: center;
  font-weight: 800;
}
.name {
  display: grid;
  min-width: 0;
  margin-right: auto;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.name small,
.score small {
  font-size: var(--mantine-font-size-xs);
  font-weight: 500;
  color: var(--color-text-secondary);
}
.score {
  display: grid;
  flex: none;
  justify-items: end;
  font-variant-numeric: tabular-nums;
}
.score small,
.ready {
  color: var(--color-notice-success);
}
.status {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--space-1);
  color: var(--color-text-secondary);
  font-size: var(--mantine-font-size-xs);
}
.status[data-ready] {
  color: var(--color-notice-success);
}
